import React from 'react';
import Section from './Section';
import ArrowUpRight from './ArrowUpRight';

const projects = [
    {
        name: 'Mehngai',
        text: "India's live grocery-inflation index, measured from real supermarket shelves. Self-healing scrapers survive store redesigns; publishes a CPI-style month-over-month number.",
        link: 'https://github.com/devnamrits/mehngai',
        stack: 'FastAPI · Next.js · scraping',
    },
    {
        name: 'BusFactor',
        text: 'A knowledge-graph agent that maps who knows what across a repository, simulates losing a person on a cloned graph, drafts a handover plan, and proves the fix by re-running the simulation.',
        link: 'https://github.com/devnamrits/BusFactor',
        stack: 'FalkorDB · FastAPI · React',
    },
    {
        name: 'MiniLLM Lab',
        text: 'Local LLM inference benchmarking — Qwen2.5-0.5B at FP16 vs GGUF Q4/Q5 quantizations on llama.cpp + Metal. Tokens/sec, RAM profiling, and speed-quality tradeoffs.',
        link: 'https://github.com/devnamrits/minillm-lab',
        stack: 'Python · llama.cpp · benchmarking',
    },
];

export default function Projects() {
    return (
        <Section id="projects" title="Projects">
            {projects.map((p) => (
                <article className="item" key={p.name}>
                    <h3 className="item-title">
                        {p.link ? (
                            <a
                                className="project-link"
                                href={p.link}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {p.name} <ArrowUpRight />
                            </a>
                        ) : (
                            p.name
                        )}
                    </h3>
                    <p className="item-text">{p.text}</p>
                    <p className="meta">{p.stack}</p>
                </article>
            ))}
        </Section>
    );
}
